import { render } from "./AppSectionBody.vue?vue&type=template&id=5c96440f&scoped=true&ts=true&lang=pug"
import script from "./AppSectionBody.vue?vue&type=script&lang=ts"
export * from "./AppSectionBody.vue?vue&type=script&lang=ts"

import "./AppSectionBody.vue?vue&type=style&index=0&id=5c96440f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c96440f"]])

export default __exports__